import React, { useState } from 'react';
import {
    StyledQuickPlayContainer,
    StyledQuickPlayWrapper,
    StyledQuickPlayInfoWrapper,
    StyledTableInfo,
    StyledTableInfoTitle,
    StyledBadge,
    StyledButtonWrapper,
    StyledBannerImageWrapper
} from './QuickPlay.styled';
import PublicImage from "../../../assets/images/eye.svg"
import PrivateImage from "../../../assets/images/eye-slash.svg"
import JoinImage from "../../../assets/images/join.svg"
import Input from '../../Input/Input';
import Button from '../../Button/Button';
import { game } from '../../../store/game';
import { SocketEmit } from '../../../types.ds';
import AvatarSelector from '../../../pages/ProfilePage/AvatarSelector/AvatarSelector';
import { checkTableIsExist } from '../../../utils/checkTableIsExist';
import { toast } from 'react-toastify';
import { toastSettings } from '../../App/App.styled';
import { getUserInfo } from '../../../utils/getUserInfo';

interface Props {
    playerId: string
    playerName: string
    playerAddress: string
    balance: number
    playerAvatar: string | undefined
    playerRole: number
    blocked: boolean
}

const QuickPlay = (props: Props) => {
    const [tableName, setTableName] = useState<string>("");
    const [avatar, setAvatar] = useState<File | null>(null);
    const [isPublic, setIsPublic] = useState<boolean>(false);

    const handleQuickPlay = async (e: HTMLButtonElement) => {
        const user = await getUserInfo(props.playerAddress);
        if (user && user.userData?.blocked) {
            toast('You are blocked', toastSettings);
            return;
        }
        e.disabled = true;
        if (tableName == "") {
            toast.error('Enter table name', toastSettings);
            e.disabled = false;
            return;
        }
        const res = await checkTableIsExist(tableName);
        if (res.existingTable) {
            toast('Table is already exist with same name.', toastSettings);
            e.disabled = false;
            return;
        }
        game.emit[SocketEmit.CreateTable](tableName, props.playerId, props.playerName, props.playerAddress, props.balance, avatar, avatar?.name, props.playerAvatar, isPublic, props.playerRole);
    }

    const handleSetTableName = (e: any) => {
        setTableName(e.target.value);
    }

    const handleSetPublic = () => {
        if (props.playerRole == 3) {
            return;
        }
        setIsPublic(!isPublic);
    }

    return (
        <StyledQuickPlayContainer>
            <StyledQuickPlayWrapper>
                <StyledQuickPlayInfoWrapper>
                    <h2 style={{ color: 'white', fontSize: '24px', lineHeight: '20px' }}>Quick Play</h2>
                    <StyledTableInfo>
                        <div>
                            <StyledTableInfoTitle>Table Name</StyledTableInfoTitle>
                            <Input width='100px' value={tableName} event={handleSetTableName} />
                        </div>
                        <div>
                            <StyledTableInfoTitle>Visibility</StyledTableInfoTitle>
                            <StyledBadge onClick={handleSetPublic}>
                                {
                                    isPublic ? (
                                        <>
                                            Public
                                            <img src={PublicImage} alt="random" sizes='10' style={{ marginRight: '0.25rem' }} />
                                        </>
                                    )
                                        :
                                        (
                                            <>
                                                Private
                                                <img src={PrivateImage} alt="random" sizes='10' style={{ marginRight: '0.25rem' }} />
                                            </>
                                        )
                                }

                            </StyledBadge>
                        </div>
                    </StyledTableInfo>
                </StyledQuickPlayInfoWrapper>
                <StyledBannerImageWrapper>
                    <AvatarSelector setAvatar={setAvatar} round={false} />
                </StyledBannerImageWrapper>
            </StyledQuickPlayWrapper>
            <StyledButtonWrapper>
                <Button padding='3rem' textSize='12px' text='Quick Play' image={JoinImage} size='small' event={handleQuickPlay} />
            </StyledButtonWrapper>
        </StyledQuickPlayContainer>
    );
}

export default QuickPlay;
